import React from 'react';
import './SessionExpiredModal.css';

const SessionExpiredModal = ({ onLogin, isTimeoutWarning, onStayLoggedIn }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{isTimeoutWarning ? 'Session Timeout Warning' : 'Session Expired'}</h2>
        <p>
          {isTimeoutWarning
            ? 'Your session will expire in 2 minutes due to inactivity. Would you like to stay logged in?'
            : 'Your session has expired. Please log in again to continue.'}
        </p>
        <div className="modal-buttons">
          {isTimeoutWarning ? (
            <>
              <button className="modal-button modal-stay-button" onClick={onStayLoggedIn}>
                Stay Logged In
              </button>
              <button className="modal-button modal-logout-button" onClick={onLogin}>
                Log Out
              </button>
            </>
          ) : (
            <button className="modal-button modal-login-button" onClick={onLogin}>
              Log In
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredModal;